/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */
import ThirdCompaniesForm from 'vcomponents/pages/forms/ThirdCompaniesForm.vue';
import ThirdContactForm from 'vcomponents/pages/forms/ThirdContactForm.vue';
import ThirdIndividualsForm from 'vcomponents/pages/forms/ThirdIndividualsForm.vue';
import ThirdOpportunitiesForm from 'vcomponents/pages/forms/ThirdOpportunitiesForm.vue';

import OverviewThird from 'vcomponents/pages/OverviewThird.vue';
import OverviewPeople from 'vcomponents/pages/OverviewPeople.vue';

import ClientOverview from 'api/overview/ClientOverview';
import ProspectOverview from 'api/overview/ProspectOverview';
import SupplierOverview from 'api/overview/SupplierOverview';
import PeopleOverview from 'api/overview/PeopleOverview';

import TabActivity from 'vcomponents/overview/tabs/TabActivity.vue';
import TabInformationsThird from 'vcomponents/overview/tabs/TabInformationsThird.vue';
import TabPreferencesThird from 'vcomponents/overview/tabs/TabPreferencesThird.vue';
import TabInformationsPeople from 'vcomponents/overview/tabs/TabInformationsPeople.vue';
import TabFinancialActivityThird from 'vcomponents/overview/tabs/TabFinancialActivityThird.vue';
import TabContacts from 'vcomponents/overview/tabs/TabContacts.vue';
import TabThirds from 'vcomponents/overview/tabs/TabThirds.vue';
import TabAddresses from 'vcomponents/overview/tabs/TabAddresses.vue';
import TabCustomfields from 'vcomponents/overview/tabs/TabCustomfields.vue';
import TabStatistics from 'vcomponents/overview/tabs/TabStatistics.vue';
import TabListing from 'vcomponents/overview/tabs/TabListing.vue';
import TabBriefcase from 'vcomponents/overview/tabs/TabBriefcase.vue';
import TabListingv1 from 'vcomponents/overview/tabs/TabListingv1.vue';
import Tab2Columns from 'vcomponents/overview/tabs/Tab2Columns.vue';
import TabAccountCreditCard from 'vcomponents/overview/tabs/TabAccountCreditCard.vue';
import TabSamTermsList from 'vcomponents/overview/tabs/TabSamTermsList.vue';
import TabSamCartsList from 'vcomponents/overview/tabs/TabSamCartsList.vue';
import TabSummary from 'vcomponents/overview/tabs/TabSummary.vue';
import Feature from 'Services/Feature';

const thirdOverviews = Object.freeze({
    client: ClientOverview,
    prospect: ProspectOverview,
    supplier: SupplierOverview,
});

export default [
    {
        path: '/thirds/:type/:id',
        name: 'third.overview',
        component: OverviewThird,
        meta: {
            menuId: 'contacts',
            overviewClass: null,
            forceTitle: true,
        },
        children: [
            {
                path: 'activity',
                alias: '',
                name: 'third.overview.activity',
                component: TabActivity,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'summary',
                alias: '',
                name: 'third.overview.summary',
                component: TabSummary,
                meta: {
                    forceTitle: true,
                },
                beforeEnter: (to, from, next) => {
                    if (to.params.type === 'client' && Feature.isEnabled('sellsy-ai')) {
                        next();
                    }
                },
            },
            {
                path: 'informations',
                name: 'third.overview.informations',
                component: TabInformationsThird,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'preferences',
                name: 'third.overview.preferences',
                component: TabPreferencesThird,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'financialactivity',
                name: 'third.overview.financialactivity',
                component: TabFinancialActivityThird,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'contacts',
                name: 'third.overview.contacts',
                component: TabContacts,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'addresses',
                name: 'third.overview.addresses',
                component: TabAddresses,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'customfields',
                name: 'third.overview.customfields',
                component: TabCustomfields,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'statistics',
                name: 'third.overview.statistics',
                component: TabStatistics,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'opportunity',
                name: 'third.overview.opportunity',
                component: TabListing,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'estimate',
                name: 'third.overview.estimate',
                component: TabListing,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'invoicedraft',
                name: 'third.overview.invoiceDraft',
                component: TabListing,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'invoice',
                name: 'third.overview.invoice',
                component: TabListing,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'delivery',
                name: 'third.overview.delivery',
                component: TabListing,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'order',
                name: 'third.overview.order',
                component: TabListing,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'creditnotedraft',
                name: 'third.overview.creditnoteDraft',
                component: TabListing,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'creditnote',
                name: 'third.overview.creditnote',
                component: TabListing,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'proforma',
                name: 'third.overview.proforma',
                component: TabListing,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'payments',
                name: 'third.overview.payments',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'bankaccount',
                name: 'third.overview.bankaccount',
                component: TabAccountCreditCard,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'recurring',
                name: 'third.overview.recurring',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'mandates',
                name: 'third.overview.mandates',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'timetracking',
                name: 'third.overview.timetracking',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'tickets',
                name: 'third.overview.tickets',
                component: Tab2Columns,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'project',
                name: 'third.overview.project',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'proposal',
                name: 'third.overview.proposal',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'emailingprofile',
                name: 'third.overview.emailingprofile',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'massmailing-mailing-list',
                name: 'third.overview.massmailingMailingList',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'massmailing-campaign-list',
                name: 'third.overview.massmailingCampaignList',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'receipts',
                name: 'third.overview.receipts',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'briefcase',
                name: 'third.overview.briefcase',
                component: TabBriefcase,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'sam-history',
                name: 'third.overview.samHistory',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'sam-plugins',
                name: 'third.overview.samPlugins',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'sam-referral',
                name: 'third.overview.samReferral',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'sam-quota',
                name: 'third.overview.samQuota',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'sam-terms',
                name: 'third.overview.samTerms',
                component: TabSamTermsList,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'sam-carts',
                name: 'third.overview.samCarts',
                component: TabSamCartsList,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'pur-order',
                name: 'third.overview.purOrder',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'pur-delivery',
                name: 'third.overview.purDelivery',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'pur-invoice',
                name: 'third.overview.purInvoice',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'pur-creditnote',
                name: 'third.overview.purCreditNote',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'sa-comments',
                name: 'third.overview.sa_comments',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'sa-emails',
                name: 'third.overview.sa_emails',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
        ],
        beforeEnter(to, from, next) {
            to.meta.menuId = 'contacts';
            to.meta.overviewClass = new thirdOverviews[to.params.type]();
            to.meta.forceTitle = true;
            next();
        },
    },
    {
        path: '/peoples/:id',
        name: 'people.overview',
        component: OverviewPeople,
        meta: {
            menuId: 'contacts',
            overviewClass: null,
            forceTitle: true,
        },
        children: [
            {
                path: 'activity',
                alias: '',
                name: 'people.overview.activity',
                component: TabActivity,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'informations',
                name: 'people.overview.informations',
                component: TabInformationsPeople,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'thirds',
                name: 'people.overview.thirds',
                component: TabThirds,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'addresses',
                name: 'people.overview.addresses',
                component: TabAddresses,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'customfields',
                name: 'people.overview.customfields',
                component: TabCustomfields,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'emailingprofile',
                name: 'people.overview.emailingprofile',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'massmailing-mailing-list',
                name: 'people.overview.massmailingMailingList',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'massmailing-campaign-list',
                name: 'people.overview.massmailingCampaignList',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'briefcase',
                name: 'people.overview.briefcase',
                component: TabBriefcase,
                meta: {
                    forceTitle: true,
                },
            },
        ],
        beforeEnter(to, from, next) {
            to.meta.menuId = 'contacts';
            to.meta.overviewClass = new PeopleOverview();
            next();
        },
    },

    {
        path: '/companies/create',
        component: ThirdCompaniesForm,
        name: 'company.form',
        props: true,
        beforeEnter(to, from, next) {
            to.params.type = 'companies';
            next();
        },
    },
    {
        path: '/individuals/create',
        component: ThirdIndividualsForm,
        name: 'individual.form',
        props: true,
        beforeEnter(to, from, next) {
            to.params.type = 'individuals';
            next();
        },
    },
    {
        path: '/contacts/create',
        component: ThirdContactForm,
        name: 'contact.form',
        props: true,
        beforeEnter(to, from, next) {
            to.params.type = 'contacts';
            next();
        },
    },
    {
        path: '/opportunities/create',
        component: ThirdOpportunitiesForm,
        name: 'opportunity.form',
        props: true,
    },
    {
        path: '/?_f=people&id=:id',
        name: 'legacy.people.overview',
    },
    {
        path: '/?_f=third&thirdid=:thirdid&thirdtype=:relationType',
        name: 'legacy.third.overview',
    },
    {
        path: '/staff/:staffid',
        name: 'legacy.staff.overview',
    },
    {
        path: '/rest/thirds/autocomplete',
        name: 'legacy.third.autocomplete',
    },
    {
        path: '/rest/thirds/:id/:type',
        name: 'legacy.third.save',
    },
    {
        path: '/rest/people/:id/:type',
        name: 'legacy.people.save',
    },
    {
        path: '/rest/third/:type/init/:id',
        name: 'overview.third.init',
    },
    {
        path: '/rest/people/init/:id',
        name: 'overview.people.init',
    },
];
